import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { trackPageview } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PageviewTracker() {
  const location = useLocation();
  const [lastPath, setLastPath] = useState("");

  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath) return;
    setLastPath(path);
    // Backend (first-party, sin cookies, datos agregados): siempre
    axios
      .post(`${API}/track/pageview`, { path, referrer: document.referrer || null })
      .catch(() => {});
    // GA / PostHog: gated por consentimiento — el helper no hace nada si no hay consent
    trackPageview(path);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
